import { motion } from "framer-motion";
import { useState } from "react";
import toast from "react-hot-toast";
import { FiFlag, FiThumbsUp } from "react-icons/fi";
import StarRating from "../UI/StarRating";

const ReviewSection = ({ reviews }) => {
  const [helpfulMap, setHelpfulMap] = useState({});

  if (!reviews?.length)
    return (
      <div className="card p-10 text-center">
        <h3 className="font-bold text-slate-800 mb-1">No reviews yet</h3>
        <p className="text-sm text-slate-500">
          Be the first to share your experience.
        </p>
      </div>
    );

  return (
    <div>
      <h2 className="text-lg font-extrabold text-slate-900 mb-4">
        Reviews <span className="text-indigo-600">({reviews.length})</span>
      </h2>
      <div className="space-y-4">
        {reviews.map((r, i) => (
          <motion.div
            key={r.id}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="card p-5"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={r.user}
                  className="w-10 h-10 rounded-full object-cover ring-2 ring-slate-100"
                />
                <div>
                  <p className="text-sm font-bold text-slate-900">{r.user}</p>
                  <p className="text-xs text-slate-400 font-medium">
                    {new Date(r.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </p>
                </div>
              </div>
              <StarRating rating={r.rating} size="xs" />
            </div>
            <h4 className="text-sm font-bold text-slate-900 mb-1.5">
              {r.title}
            </h4>
            <p className="text-sm text-slate-600 leading-relaxed mb-4">
              {r.comment}
            </p>
            <div className="flex items-center gap-4 pt-3 border-t-2 border-slate-100">
              <button
                onClick={() => {
                  setHelpfulMap((p) => ({ ...p, [r.id]: !p[r.id] }));
                  toast.success("Thanks!");
                }}
                className={`flex items-center gap-1.5 text-xs font-bold transition-colors ${helpfulMap[r.id] ? "text-indigo-600" : "text-slate-400 hover:text-slate-700"}`}
              >
                <FiThumbsUp size={12} /> Helpful (
                {r.helpful + (helpfulMap[r.id] ? 1 : 0)})
              </button>
              <button className="flex items-center gap-1.5 text-xs font-bold text-slate-400 hover:text-red-500 transition-colors">
                <FiFlag size={12} /> Report
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ReviewSection;
